<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.claim_request.step0.step') }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.claim_request.step0.title') }}</h1>
      </div>
      <div class="project-content">
        <form @submit="onSubmit" ref="form" id="formInformations" class="std-form">
          <div class="form-group">
            <div class="form-label-container">
              <label for="company" class="control-label required">
                {{ Translator('soprasolar.claim_request.step0.form.company') }}
              </label>
            </div>
            <input type="text" id="company" class="form-control" v-model="form.company" required>
          </div>
          <div class="form-group">
            <div class="form-label-container">
              <label for="firstName" class="control-label required">
                {{ Translator('soprasolar.claim_request.step0.form.first_name') }}
              </label>
            </div>
            <input type="text" id="firstName" class="form-control" v-model="form.firstName" required>
          </div>
          <div class="form-group">
            <div class="form-label-container">
              <label for="lastName" class="control-label required">
                {{ Translator('soprasolar.claim_request.step0.form.last_name') }}
              </label>
            </div>
            <input type="text" id="lastName" class="form-control" v-model="form.lastName" required>
          </div>
          <div class="form-group">
            <div class="form-label-container">
              <label for="email" class="control-label required">
                {{ Translator('soprasolar.claim_request.step0.form.email') }}
              </label>
            </div>
            <input type="email" id="email" class="form-control" v-model="form.email" required>
          </div>
          <div class="form-group">
            <div class="form-label-container">
              <label for="phoneNumber" class="control-label required">
                {{ Translator('soprasolar.claim_request.step0.form.phone_number') }}
              </label>
            </div>
            <input type="text" id="phoneNumber" class="form-control" v-model="form.phoneNumber" required>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="coefficient" class="control-label required">
                {{ Translator('soprasolar.claim_request.step0.form.document_reference.label') }}
              </label>
            </div>

            <div class="radios">
              <div class="radio">
                <input class="radio-input" type="radio" id="document_reference_delivery_note" name="document_reference" v-model="form.documentReference" value="delivery_note" required>
                <label class="radio-label" for="document_reference_delivery_note">
                  <p class="radio-label-text">{{ Translator('soprasolar.claim_request.step0.form.document_reference.delivery_note') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" type="radio" id="document_reference_arc" name="document_reference" v-model="form.documentReference" value="arc" required>
                <label class="radio-label" for="document_reference_arc">
                  <p class="radio-label-text">{{ Translator('soprasolar.claim_request.step0.form.document_reference.arc') }}</p>
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="document_number" class="control-label required">
                {{ Translator('soprasolar.claim_request.step0.form.document_number') }}
              </label>
            </div>
            <input type="text" id="document_number" class="form-control" v-model="form.documentNumber" required>
          </div>
          <div class="form-group">
            <div class="form-label-container">
              <label for="receipt_date" class="control-label required">
                {{ Translator('soprasolar.claim_request.step0.form.receipt_date') }}
              </label>
            </div>
            <flat-pickr v-model="form.receiptDate" required :config="dateConfig"></flat-pickr>
          </div>
          <div class="form-group">
            <div class="form-label-container">
              <label for="receipt_location" class="control-label required">
                {{ Translator('soprasolar.claim_request.step0.form.receipt_location') }}
              </label>
            </div>
            <input type="text" id="receipt_location" class="form-control" v-model="form.receiptLocation" required>
          </div>

        </form>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="submit" class="button-flat" form="formInformations" :disabled="isLoading">
          {{ Translator('soprasolar.claim_request.next') }}
          <i class="ic ic-arrow-right" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
      </div>
    </div>
    <p class="project-legend">* {{ Translator('soprasolar.claim_request.required_field') }}</p>
  </div>
</template>
<script>
import FormControl from 'aw-front-helpers/classes/formControl';
import AppControlService from '@/soprasolar-claim/services/AppControl';
import { French } from "flatpickr/dist/l10n/fr.js"

export default {
  name: 'step-0',
  components: {},
  data () {
    return {
      datas: AppControlService.datas,
      isLoading: false,
      form: {},
      dateConfig: {
        dateFormat: 'd/m/Y',
        locale: French,
        maxDate: new Date()
      },
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
    this._form = new FormControl(this.$refs.form);
    if(this.datas.step0) this.form = this.datas.step0;
  },

  methods: {
    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this._form.isValidate) {
        if(this.isLoading) return;
        this.isLoading = true;
        AppControlService.update('step0', this.form).then( () => {
          AppControlService.goToNextStep();
        }).catch(console.error).then(() => {
          this.isLoading = false;
        })
      }
    },

    onPrevious() {
      AppControlService.goToPrevStep();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      if(this.datas.step0) this.form = this.datas.step0;
    }
  }
};
</script>